import { Type, type Static } from "@sinclair/typebox";
const uuid = Type.String({ format: "uuid" });
const nullableString = Type.Union([Type.String(), Type.Null()]);
const transferProperties = {
  condominiumVersion: Type.Integer({ minimum: 1 }),
  administratorId: uuid,
  prefix: Type.String({ pattern: "^[A-Z]{2,5}$", minLength: 2, maxLength: 5 }),
  clientNumber: Type.String({ pattern: "^[1-9][0-9]{0,8}$", maxLength: 9 }),
  jobIds: Type.Array(uuid, { uniqueItems: true, maxItems: 200 }),
};
export const AdministratorTransferRequestSchema = Type.Object(
  transferProperties,
  { additionalProperties: false },
);
export const AdministratorTransferApplySchema = Type.Object(
  {
    ...transferProperties,
    operationId: uuid,
    previewToken: Type.String({ pattern: "^[a-f0-9]{64}$" }),
  },
  { additionalProperties: false },
);
export const AdministratorTransferContextSchema = Type.Object({
  condominiumId: uuid,
  condominiumName: Type.String(),
  condominiumVersion: Type.Integer({ minimum: 1 }),
  administratorId: Type.Union([uuid, Type.Null()]),
  prefix: Type.String(),
  clientNumber: Type.String(),
  jobs: Type.Array(
    Type.Object({
      id: uuid,
      code: Type.String(),
      title: Type.String(),
      managementYear: Type.Integer(),
      version: Type.Integer({ minimum: 1 }),
      status: Type.String(),
      eligible: Type.Boolean(),
      reason: nullableString,
    }),
  ),
});
export const AdministratorTransferPreviewSchema = Type.Object({
  previewToken: Type.String(),
  condominiumId: uuid,
  condominiumName: Type.String(),
  condominiumVersion: Type.Integer({ minimum: 1 }),
  previousAdministratorName: nullableString,
  administratorName: Type.String(),
  prefix: Type.String(),
  clientNumber: Type.String(),
  jobs: Type.Array(
    Type.Object({
      id: uuid,
      version: Type.Integer({ minimum: 1 }),
      managementYear: Type.Integer(),
      oldCode: Type.String(),
      newCode: Type.String(),
      title: Type.String(),
    }),
  ),
  warnings: Type.Array(Type.String()),
});
export type AdministratorTransferRequest = Static<
  typeof AdministratorTransferRequestSchema
>;
export type AdministratorTransferApply = Static<
  typeof AdministratorTransferApplySchema
>;
export type AdministratorTransferContext = Static<
  typeof AdministratorTransferContextSchema
>;
export type AdministratorTransferPreview = Static<
  typeof AdministratorTransferPreviewSchema
>;
